import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbToggleModule, NbActionsModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { EcoleRoutingModule, routedComponents } from './ecole-routing.module';
import { EditEcoleComponent } from './edit-ecole/edit-ecole.component';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CKEditorModule } from 'ngx-ckeditor';
import { EditAdmissionComponent } from './edit-admission/edit-admission.component';
import { EditFaculteComponent } from './edit-faculte/edit-faculte.component';


@NgModule({
  imports: [
    NbCardModule,
    NbTreeGridModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    EcoleRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    CKEditorModule,
    NbActionsModule,
  ],
  entryComponents: [
    EditEcoleComponent,
    EditAdmissionComponent,
    EditFaculteComponent,
  ],
  declarations: [
    EditEcoleComponent,
    EditAdmissionComponent,
    EditFaculteComponent,
    ...routedComponents,
  ],
})
export class EcoleModule { }
